import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";

interface ValidationAlertProps {
  errors: Record<string, string>;
  show: boolean;
}

export function ValidationAlert({ errors, show }: ValidationAlertProps) {
  if (!show || Object.keys(errors).length === 0) return null;

  const errorList = Object.entries(errors);

  return (
    <Alert variant="destructive" className="mb-4">
      <AlertCircle className="h-4 w-4" />
      <AlertDescription>
        <div className="font-medium mb-2">
          {errorList.length} error{errorList.length !== 1 ? 's' : ''} must be fixed before approval:
        </div>
        <ul className="list-disc list-inside space-y-1 text-sm">
          {errorList.map(([field, message]) => (
            <li key={field}>{message}</li>
          ))}
        </ul>
      </AlertDescription>
    </Alert>
  );
}